import $ from 'jquery';
import 'External/jquery-ui-datepicker';

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

if ($.datepicker) {
    $('input.datepicker').datepicker({
        autoclose: true,
        changeMonth: true,
        changeYear: true,
        dateFormat: 'yy-mm-dd'
    });
}
